/* unplugin-vue-components disabled */import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = ["id", "onClick"];
var _hoisted_2 = ["id"];
import { watch } from 'vue';
export default {
  __name: 'tabs',
  props: {
    modelValue: '',
    name: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: []
    },
    defaultChild: {
      type: Object,
      default: {
        label: '',
        value: ''
      }
    },
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    color: {
      type: String,
      default: '#000000'
    },
    activeColor: {
      type: String,
      default: '#248f83'
    }
  },
  emits: ['update:modelValue'],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emit = __emit;
    var current_type = ref('');
    var change_tag_style = () => {
      nextTick(() => {
        var _document$getElementB;
        var bottom_line = document.getElementById('bottom_' + props.name);
        var index_ = props.list.findIndex(x => x[props.defaultChild.value] == current_type.value);
        if (index_ == -1) {
          return false;
        }
        var curretn_tag_width = ((_document$getElementB = document.getElementById('tab_item_' + props.name + index_)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.clientWidth) || 0;
        var pre_tag_widt_all = 0;
        if (index_ != 0) {
          for (var i = index_ - 1; i > -1; i--) {
            var _document$getElementB2;
            pre_tag_widt_all += ((_document$getElementB2 = document.getElementById('tab_item_' + props.name + i)) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.clientWidth) || 0;
          }
        }
        bottom_line.style.left = 20 + index_ * 40 + pre_tag_widt_all + 'px';
        bottom_line.style.width = curretn_tag_width + 'px';
      });
    };
    var handle_change = item => {
      current_type.value = item[props.defaultChild.value];
      emit('update:modelValue', current_type.value);
    };
    /**
     * 切换tab的动画效果
     */
    watch(() => {
      return current_type.value;
    }, () => {
      change_tag_style();
    }, {
      immediate: true
    });
    watch(() => {
      return props.modelValue;
    }, () => {
      current_type.value = props.modelValue;
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: "tag_row",
        style: _normalizeStyle({
          backgroundColor: __props.backgroundColor
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (tab_item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass([_unref(current_type) == tab_item[__props.defaultChild.value] ? 'isactive' : 'tab_item']),
          style: _normalizeStyle(_unref(current_type) == tab_item[__props.defaultChild.value] ? '--color:' + __props.activeColor : '--color:' + __props.color),
          id: 'tab_item_' + __props.name + index,
          onClick: $event => handle_change(tab_item)
        }, [_createTextVNode(_toDisplayString(tab_item[__props.defaultChild.label]) + " ", 1), _withDirectives(_createElementVNode("i", {
          class: "tip_s"
        }, _toDisplayString(tab_item.count > 99 ? '99+' : tab_item.count), 513), [[_vShow, tab_item.count && tab_item.count != 0]])], 14, _hoisted_1);
      }), 128)), _createElementVNode("i", {
        class: "bottom_line",
        id: 'bottom_' + __props.name,
        style: _normalizeStyle({
          'background-color': __props.activeColor
        })
      }, null, 12, _hoisted_2)], 4);
    };
  }
};